import { Switch } from '@thanx/uikit/switch'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'
import { merchantTheme } from 'theme'

const t = buildTranslate('components.side_nav')

type Props = {
  items: string[]
  current: string
  all?: string
  onClick: (item: string) => void
  noBorderRadius?: boolean
}

const Item = ({ onClick, value, active, noBorderRadius }) => {
  const [css] = useStyletron()

  return (
    <button
      type="button"
      onClick={onClick}
      className={`p-m text-left border border-0 ${
        !noBorderRadius ? 'border-radius-5' : ''
      } ${css({
        background: active ? merchantTheme.colors.belizeHole10 : 'transparent',
        color: active
          ? merchantTheme.colors.grey90
          : merchantTheme.colors.grey70,
        fontWeight: active ? 'bold' : 'normal',
        borderRadius: noBorderRadius ? '0' : undefined,
      })}`}
    >
      {value || t('other')}
    </button>
  )
}

const SideNav: React.FC<Props> = ({
  items,
  current,
  all,
  onClick,
  noBorderRadius,
}) => {
  return (
    <div className="d-flex flex-column">
      <Switch condition={!!all}>
        <Item
          onClick={() => onClick('all')}
          value={all}
          active={current === 'all'}
          noBorderRadius={noBorderRadius}
        />
      </Switch>
      {items.map(item => (
        <Item
          key={item}
          onClick={() => onClick(item)}
          value={item}
          active={current === item}
          noBorderRadius={noBorderRadius}
        />
      ))}
    </div>
  )
}

export default SideNav
